import type { PaymentTier } from '../types/i18n'

/**
 * The Croatian price-control decision calls this the additional price.
 * It is the price that applied to the same service on 10 September 2026.
 * Source: NN 101/2026-1212, points II, III and VI.
 * Keep these values tied to the archived price list/Stripe configuration
 * before changing them.
 */
export const ADDITIONAL_PRICE_DATE = '2026-09-10'

// Versioned public file: publish a new filename whenever the price list changes.
export const PUBLIC_PRICE_CATALOG_PATH = '/cjenik/web_weddingcamera.app_online_0001_2026-09-21T122758+0200.csv'

export interface WeddingCameraPrice {
	currentPrice: string
	anchorPrice: string
}

export const WEDDING_CAMERA_PRICES: Record<PaymentTier, WeddingCameraPrice> = {
	basic: {
		currentPrice: '14,99€',
		anchorPrice: '14,99€'
	},
	premium: {
		currentPrice: '34,99€',
		anchorPrice: '34,99€'
	},
	exclusive: {
		currentPrice: '49,99€',
		anchorPrice: '49,99€'
	}
}
